import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-slateGray absolute left-0 top-0 w-full h-full" }
const _hoisted_2 = { class: "text-card one-way w-11/12 sm:w-5/6 darker-text-shadow text-center text-stone text-bodyLg lg:text-bodyXl 2xl:text-body2xl flex flex-col mt-10 sm:mt-0 gap-0 sm:gap-15px 2xl:gap-30px" }
const _hoisted_3 = { class: "hidden sm:block" }
const _hoisted_4 = { class: "hidden sm:block" }
const _hoisted_5 = { class: "block sm:hidden" }
const _hoisted_6 = {
  id: "mobile-living-infra-link",
  class: "living-infra-link relative text-poppy whitespace-nowrap cursor-pointer pointer-events-auto",
  tabindex: "1",
  href: "#"
}
const _hoisted_7 = { class: "flex flex-row justify-center items-stretch gap-3 sm:gap-30px my-6 xs:my-1 lg:my-4" }

import { reactive, onMounted, computed } from 'vue'
import { MJPSection, MJPSectionData } from './types'
import useLanguage from '@/composables/useLanguage'
import useSkipToTour from '@/composables/mjp/useSkipToTour'
import DrawnHighlight from '@/assets/svg/DrawnHighlight.vue'
import ChevronDown from '@/assets/svg/ChevronDown.vue'
import { useEventBus } from '@vueuse/core'
import ResponsiveBackgroundImage from '../general/ResponsiveBackgroundImage.vue'
import BottomGradient from '../general/BottomGradient.vue'
import SectionBase from '../general/SectionBase.vue'
import SectionPage from '../general/SectionPage.vue'
import TitleComponent from '../general/TitleComponent.vue'
import ResponsiveBackgroundVideo from '../general/ResponsiveBackgroundVideo.vue'
import { useSettingsStore } from '@/store/settings'
import PanelButton from '../general/PanelButton.vue'
import { ButtonPanelSizing } from '../general/types'

interface Props {
  sectionData: MJPSectionData
  currentSection: MJPSection
  currentSectionHasLoaded: boolean
  currentPage: number
  forward: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleSection',
  props: {
    sectionData: null,
    currentSection: null,
    currentSectionHasLoaded: { type: Boolean },
    currentPage: null,
    forward: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  sectionData: MJPSectionData
  currentSection: MJPSection
  currentSectionHasLoaded: boolean
  currentPage: number
  forward: boolean
}


const interfaceText = useLanguage('interface')
const sectionText = useLanguage('title')
const sectionChangedBus = useEventBus('section-changed')
const knowledgeBaseBus = useEventBus('open-article')
const settingsStore = useSettingsStore()
const state = reactive({
  drawnHighlightVisible: false,
})

const handleClickContinueToHistoryBtn = (evt) => {
  sectionChangedBus.emit({
    section: MJPSection.History,
    pageNumber: 0,
    forward: true,
    lastSection: props.currentSection,
  })
}

const showDrawnHighlight = () => {
  state.drawnHighlightVisible = true
}

const hideDrawnHighlight = () => {
  state.drawnHighlightVisible = false
}

const setupArticleLink = () => {
  const links = document.getElementsByClassName('living-infra-link')
  for (let i = 0; i < links.length; i++) {
    let link = links[i] as HTMLAnchorElement
    link.onclick = () => {
      knowledgeBaseBus.emit('sZ9jJ1SFSnzDtDyJ2ByzhA') // living infrastructure article
    }
  }
}

const sectionIsActive = computed(() => {
  return props.currentSection == props.sectionData.section
})

const pageRangeIsActive = (lo, hi) => {
  if (sectionIsActive.value && props.currentSectionHasLoaded) {
    return props.currentPage >= lo && props.currentPage <= hi
  } else {
    return false
  }
}

const opacityForPageRange = (lo, hi) => {
  return pageRangeIsActive(lo, hi) ? 1 : 0
}

onMounted(() => {
  setupArticleLink()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ResponsiveBackgroundImage, {
      id: "title-bg",
      dir: "mjp",
      sm: "title-bg-end-sm.jpg",
      md: "title-bg-end-md.jpg",
      lg: "title-bg-end-lg.jpg",
      alt: _unref(sectionText).altText,
      isActive: pageRangeIsActive(0, 0)
    }, null, 8, ["alt", "isActive"]),
    _createVNode(ResponsiveBackgroundVideo, {
      manifest: "https://customer-vt66666ts449vzd9.cloudflarestream.com/e858264baccb9668d51e6d8c62a41655/manifest/video.m3u8",
      sectionData: props.sectionData,
      scrollOffset: { proxyPosition: '50% 50%', offsetX: 960 },
      currentSection: props.currentSection,
      currentSectionHasLoaded: props.currentSectionHasLoaded,
      currentPage: props.currentPage,
      minPage: 0,
      maxPage: 0,
      dir: "mjp"
    }, null, 8, ["sectionData", "currentSection", "currentSectionHasLoaded", "currentPage"]),
    _createElementVNode("div", {
      class: _normalizeClass(["absolute top-0 left-0 w-full h-full bg-black pointer-events-none", {
        'opacity-30': !_unref(settingsStore).highContrast,
        'opacity-60': _unref(settingsStore).highContrast,
      }])
    }, null, 2),
    _createVNode(BottomGradient, { class: "hidden sm:block" }),
    _createVNode(SectionBase, {
      thisSection: props.sectionData.section,
      currentSection: props.currentSection,
      currentSectionHasLoaded: props.currentSectionHasLoaded,
      currentPage: props.currentPage,
      forward: props.forward,
      position: props.sectionData.focalPoint
    }, {
      default: _withCtx(() => [
        _createVNode(SectionPage, {
          id: `${props.sectionData.section}-1`,
          class: "flex flex-col items-center justify-center"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(TitleComponent, {
                text: _unref(sectionText).heading,
                size: "lg"
              }, null, 8, ["text"]),
              _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(sectionText).paragraphOne), 1),
              _createElementVNode("p", _hoisted_4, [
                _createTextVNode(_toDisplayString(_unref(sectionText).paragraphTwoA) + " ", 1),
                _createElementVNode("a", {
                  href: "#",
                  id: "desktop-living-infra-link",
                  class: "living-infra-link relative text-poppy focus:outline-0 whitespace-nowrap cursor-pointer pointer-events-auto",
                  tabindex: "1",
                  onFocus: showDrawnHighlight,
                  onBlur: hideDrawnHighlight,
                  onMouseenter: showDrawnHighlight,
                  onMouseleave: hideDrawnHighlight
                }, [
                  _createTextVNode(_toDisplayString(_unref(sectionText).livingInfrastructure), 1),
                  (state.drawnHighlightVisible)
                    ? (_openBlock(), _createBlock(DrawnHighlight, {
                        key: 0,
                        class: "hidden cursor-pointer sm:block absolute sm:w-[110%] -left-[7%] -top-7 md:-top-7 2xl:-top-6 pointer-events-none"
                      }))
                    : _createCommentVNode("", true)
                ], 32),
                _createTextVNode(" " + _toDisplayString(_unref(sectionText).paragraphTwoB), 1)
              ]),
              _createElementVNode("p", _hoisted_5, [
                _createTextVNode(_toDisplayString(_unref(sectionText).paragraphCompactA) + " ", 1),
                _createElementVNode("a", _hoisted_6, _toDisplayString(_unref(sectionText).livingInfrastructure), 1),
                _createTextVNode(" " + _toDisplayString(_unref(sectionText).paragraphCompactB), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(PanelButton, {
                  identifier: "thumbnailStartFromBeginning",
                  image: "mjp/thumbnailStartFromBeginning.jpg",
                  class: "w-1/2",
                  altText: _unref(sectionText).startFromBeginningAltText,
                  title: _unref(interfaceText).startFromBeginning,
                  subtitle: _unref(interfaceText).twentyFiveMinuteRead,
                  sizing: _unref(ButtonPanelSizing).Large,
                  tabindex: 2,
                  onClick: handleClickContinueToHistoryBtn
                }, null, 8, ["altText", "title", "subtitle", "sizing"]),
                _createVNode(PanelButton, {
                  identifier: "thumbnailSkipToTour",
                  image: "mjp/thumbnailSkipToTour.jpg",
                  class: "w-1/2",
                  altText: _unref(sectionText).skipToWalkingTourAltText,
                  title: _unref(interfaceText).skipToWalkingTour,
                  subtitle: _unref(interfaceText).twentyMinuteRead,
                  sizing: _unref(ButtonPanelSizing).Large,
                  tabindex: 3,
                  onClick: _cache[0] || (_cache[0] = () => _unref(useSkipToTour)(props.currentSection))
                }, null, 8, ["altText", "title", "subtitle", "sizing"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["id"])
      ]),
      _: 1
    }, 8, ["thisSection", "currentSection", "currentSectionHasLoaded", "currentPage", "forward", "position"])
  ]))
}
}

})